import App from './components/App/App';
import ShowMoreButtonConstructor from './components/ShowMoreButton/ShowMoreButton';
import SmartPaymentButtonConstructor from './components/SmartPaymentButton/SmartPaymentButton';
import { CheckoutButtonInitializer, CheckoutKitLoader, InitialProps } from './types';

declare global {
  interface Window {
    checkoutKitLoader?: CheckoutKitLoader;
    checkoutButtonInitializer?: CheckoutButtonInitializer;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    BigCommerce?: {
      initializeSmartPaymentButtons?(props: InitialProps): Promise<void>;
    };
  }
}

window.BigCommerce = window.BigCommerce ?? {};

window.BigCommerce.initializeSmartPaymentButtons = async (props: InitialProps): Promise<void> => {
  if (!window.checkoutKitLoader) {
    throw new Error('Can not initialize the app because checkoutKitLoader is not loaded');
  }

  const smartPaymentButtonConstructor = new SmartPaymentButtonConstructor();
  const showMoreButtonConstructor = new ShowMoreButtonConstructor();
  const app = new App(smartPaymentButtonConstructor, showMoreButtonConstructor);

  await app.initialize(props);
};
